module.exports = __webpack_public_path__ + "img/six.0312f301.png";